import Glide from '@glidejs/glide';

const paintingsSlider = document.querySelector('.paintings-slider');
paintingsSlider && new Glide(paintingsSlider, {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  gap: 30,
  autoplay: 3000,
  animationDuration: 1000
}).mount();

const timelineSliders = document.querySelectorAll('.timeline-slider');
const timelineSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000
};

Object.values(timelineSliders).map(slider => {
  new Glide(slider, timelineSliderOptions).mount();
});

const contentSliders = document.querySelectorAll('.content-slider');
const contentSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000
};

Object.values(contentSliders).map(slider => {
  new Glide(slider, contentSliderOptions).mount();
});

const eventSliders = document.querySelectorAll('.event-slider');
const eventSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 1,
  autoplay: 5000,
  animationDuration: 1000
};

Object.values(eventSliders).map(slider => {
  new Glide(slider, eventSliderOptions).mount();
});
